var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgHelpFilled = function SvgHelpFilled(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#111827",
    fillRule: "evenodd",
    d: "M12 2.25A9.744 9.744 0 0 0 2.25 12 9.744 9.744 0 0 0 12 21.75 9.75 9.75 0 0 0 21.75 12 9.75 9.75 0 0 0 12 2.25Zm-.01 4.83a2.743 2.743 0 0 0-2.75 2.75.75.75 0 1 0 1.5 0c0-.696.554-1.25 1.25-1.25.688 0 1.25.557 1.25 1.25 0 .407-.207.64-.652.95-.563.376-1.338 1.011-1.338 2.22v.25a.75.75 0 0 0 1.5 0V13c0-.427.219-.671.676-.976l.012-.008c.531-.369 1.302-.994 1.302-2.186a2.75 2.75 0 0 0-2.75-2.75Zm.009 8.17h-.01c-.02 0-.042 0-.062.002a.997.997 0 0 0-.928.998c0 .525.427 1 1 1a1 1 0 0 0 .704-.296A1 1 0 0 0 13 16.25a1.004 1.004 0 0 0-1-1Z",
    clipRule: "evenodd"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgHelpFilled);
export default ForwardRef;